import React, { createContext, useContext, useMemo, useState } from 'react';

/**
 * Campuzon ships with seeded demonstration records so every surface can be
 * judged with content in it. That is useful for review and dishonest for a real
 * first user, who would otherwise be shown someone else's courses, orders and
 * notes as though they were their own.
 *
 * This holds which of the two the product is presenting:
 *
 *  - 'demo' — seeded records, labelled as demonstration data.
 *  - 'new'  — a genuinely empty account, so every surface must answer what it is,
 *             why it matters and what to do first.
 *
 * It is a presentation mode, not a permission. Nothing here decides access.
 */
export type DataMode = 'demo' | 'new';
interface DataModeContextValue {
  mode: DataMode;
  isNew: boolean;
  setMode: (mode: DataMode) => void;
}
const DataModeContext = createContext<DataModeContextValue | null>(null);
export function DataModeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [mode, setMode] = useState<DataMode>('demo');
  const value = useMemo<DataModeContextValue>(() => ({
    mode,
    isNew: mode === 'new',
    setMode
  }), [mode]);
  return <DataModeContext.Provider value={value} data-id="element-5767" data-mp="204648shdfiwq">{children}</DataModeContext.Provider>;
}
export function useDataMode(): DataModeContextValue {
  const context = useContext(DataModeContext);
  // Surfaces rendered outside the provider (public pages) behave as demo rather
  // than throwing: a marketing page has no account to be empty.
  return context ?? {
    mode: 'demo',
    isNew: false,
    setMode: () => undefined
  };
}